// extracted by mini-css-extract-plugin
export default {"sectionContent":"Offer_sectionContent__qMfyj","offer":"Offer_offer__gtaFz","scroll":"Offer_scroll__l8EOr"};